import script from "./searchInput.vue?vue&type=script&lang=js"
export * from "./searchInput.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__